module.exports = __webpack_public_path__ + "static/media/MM.71272df1.svg";